import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const TechLoan = ({hibisId}) => {

  return (
    <>
      <Header />
      <Hero image="oskar-tehnologija.jpg" xPos="71%" yPos="28%" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>Nova tehnologija je bližje, kot si mislite!</h1>
                    <p className="text-left">
                      Elektronika, ki vam olajša življenje, ni več nedosegljiva.                      
                    </p>
                    <p className="text-left red-text">
                      Z Addiko kreditom lahko hitro pridete do novega računalnika, telefona ali gospodinjskega aparata.
                    </p>
                    <p className="text-left">
                      Enostavno, pregledno in brez visokih stroškov. <b>Izpolnite obrazec in kmalu vas bomo poklicali.</b>
                    </p>
                    <p className="text-left text-small">
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        Addiko banka
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                <Col md={5} className="p-3">
                  <Form guid="a247eab1-e16a-45fa-b2c9-53a7dca8f4b6" hibisId={hibisId} />
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}